import { z } from 'zod';

export default (message: string): z.ZodString => z.string({ error: message }).min(1, message);
